export default __webpack_public_path__ + "static/media/youtube-thumbnail.1fd790a0.png";